<script>
import { onMounted, nextTick } from 'vue'

export default {
  setup(){
    function isDesktop() {
      return window.innerWidth >= 960;
    }
    const setCollapseEvent = (header) => {
      header.addEventListener("click", (event) => {
            const $el = event.target;
            const $collapse = $el.nextElementSibling;
            const isOpen = $el.classList.contains("menu-footer__link--open");

            // If the clicked element is not open, close all open menus
            if (
              !isOpen &&
              document.querySelectorAll(".menu-footer__link--open").length > 0
            ) {
              document
                .querySelectorAll(".menu-footer__link--open")
                .forEach((element) => {
                  element.classList.remove("menu-footer__link--open");
                });
              document.querySelectorAll(".menu-footer--open").forEach((element) => {
                element.classList.remove("menu-footer--open");
              });
            }

            // Toggle the clicked element's open state
            $el.classList.toggle("menu-footer__link--open");
            $collapse.classList.toggle("menu-footer--open");
          });
        }

    onMounted(async () => {
      await nextTick();
      const headers = document.querySelectorAll(".menu-footer__item--1");
      Array.from(headers).forEach(setCollapseEvent);
      if (isDesktop()) {
          // if (this.isDesktop) {
          let element = document.querySelectorAll("li.menu-footer__item-accueil");
          document
            .querySelectorAll("li.menu-footer__item-accueil")
            .forEach((element) => {
              console.log(
                element.parentNode.parentElement.firstChild.setAttribute(
                  "href",
                  element.firstChild.getAttribute("href")
                )
              );
            });
          if (element.length > 0) {
            //element.appendTo(element.parent());
          }
        }
    })
  }
}


</script>

<style lang="sass">
@import ../../../common/styles/mixins
@import ../../../common/styles/settings
@import MenuFooter
</style>
